var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Linkedin",on:{"click":_vm.loginWithLinkedin}},[_c('q-icon',[_c('IconLinkedin')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }